import store from '../../init/store.js'

export function sendReadyToFirebase(callback) {
  const myId = store.getState().crew.logggedInUserId;

  window.roomRef.child('readyClients').child(myId).set(true).then(callback);
}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase-send-ready.js